import { ReactNode } from "react";

import Box from "ds/components/Box";
import CardTitle from "ds/components/Card/components/Title";
import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import TooltipInfo from "ds/components/TooltipInfo";
import { AnalyticsPage } from "hooks/useAnalytics";

const DashboardItemTitle = ({
  title,
  infoTooltip,
  headerActions,
  moreActions,
  onHide,
}: {
  title: string;
  infoTooltip?: string;
  headerActions?: ReactNode;
  moreActions?: {
    link: string;
    title: string;
    analyticsPage: AnalyticsPage;
    analyticsTitle: string;
    analyticsProps?: Record<string, string>;
  }[];
  onHide?: () => void;
}) => {
  return (
    <Box justify="between" align="center" grow="1">
      <Box align="center" gap="large" grow="1">
        <CardTitle tag="span">{title}</CardTitle>
        {infoTooltip && <TooltipInfo>{infoTooltip}</TooltipInfo>}
      </Box>
      <Box align="center" gap="medium">
        {headerActions}
        <DropdownMenuEllipsis tooltip="Settings" buttonVariant="ghost">
          <DropdownMenuItem onAction={onHide}>Hide</DropdownMenuItem>
          {moreActions?.map(({ link, title, analyticsPage, analyticsTitle, analyticsProps }, i) => (
            <DropdownMenuItem
              analyticsPage={analyticsPage}
              analyticsTitle={analyticsTitle}
              analyticsProps={analyticsProps}
              key={i}
              href={link}
            >
              {title}
            </DropdownMenuItem>
          ))}
        </DropdownMenuEllipsis>
      </Box>
    </Box>
  );
};

export default DashboardItemTitle;
